<template>
  <v-dialog
    v-model="dialogReporteVendedora.estatus"
    max-width="1800"
    persistent
  >
    <v-card class="shadowCard">
		  <v-card-title primary-title>
        <v-img src="@/assets/iconos/secretaria.png" max-width="30" class="mr-2"></v-img>
		    <span>
		    	Reporte de <b class="blue--text">BUEN</b> seguimiento por Vendedora!
		    </span>
		    <v-spacer></v-spacer>

		  </v-card-title>

		  <v-card-text class="mt-6">
		    <v-row>
		    	<v-col cols="12">
		    		<v-card class="elevation-0">
		    			<v-card-title primary-title class="text-body-1">
		    			  Reporte Inbi
		    			  <v-spacer></v-spacer>
		    			  <v-btn 
				          class="mr-2" 
				          small dark color="green"
				          @click="exportExcel( vendInbi  , 'REPORTE_INBI')"
				          tile
				        >
				          <v-icon small>mdi-microsoft-excel</v-icon>
				        </v-btn>
		    			</v-card-title>
		    			<v-card-text>
			    		  <v-data-table
				          :headers="headers"
				          :items="vendInbi"
				          class="elevation-0"
				          dense
				          mobile-breakpoint="200"
				          item-key="nombre"
				        >

				        	<template v-slot:item.prospectos="{ item }">
				        		<v-chip color="primary" small @click="prospectosAll = item.prospectos, dialogReporte = true">{{ item.prospectos.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.seguimiento="{ item }">
				        		<v-chip color="primary" small @click="prospectosAll = item.seguimiento, dialogReporte = true">{{ item.seguimiento.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.tarda="{ item }">
				        		<v-chip color="primary" small @click="prospectosAll = item.tarda, dialogReporte = true">{{ item.tarda.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.bueno="{ item }">
				        		<v-chip color="green" dark small @click="prospectosAll = item.bueno, dialogReporte = true">{{ item.bueno.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.regular="{ item }">
				        		<v-chip color="orange" dark small @click="prospectosAll = item.regular, dialogReporte = true">{{ item.regular.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.malo="{ item }">
				        		<v-chip color="black" dark small @click="prospectosAll = item.malo, dialogReporte = true">{{ item.malo.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.sin_seguimiento="{ item }">
				        		<v-chip color="red" dark small @click="prospectosAll = item.sin_seguimiento, dialogReporte = true">{{ item.sin_seguimiento.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.cliente_nunca_respondio="{ item }">
				        		<v-chip color="blue" dark small @click="prospectosAll = item.cliente_nunca_respondio, dialogReporte = true">{{ item.cliente_nunca_respondio.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.cliente_dejo_responder="{ item }">
				        		<v-chip color="pink" dark small @click="prospectosAll = item.cliente_dejo_responder, dialogReporte = true">{{ item.cliente_dejo_responder.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.cliente_en_espera="{ item }">
				        		<v-chip color="yellow" small @click="prospectosAll = item.cliente_en_espera, dialogReporte = true">{{ item.cliente_en_espera.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.msnDuplicado="{ item }">
				        		<v-chip color="red" dark small @click="prospectosAll = item.msnDuplicado, dialogReporte = true">{{ item.msnDuplicado.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.pdfInicio="{ item }">
				        		<v-chip color="blue" dark small @click="prospectosAll = item.pdfInicio, dialogReporte = true">{{ item.pdfInicio.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.clienteEspera="{ item }">
				        		<v-chip color="orange" dark small @click="prospectosAll = item.clienteEspera, dialogReporte = true">{{ item.clienteEspera.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.sinError="{ item }">
				        		<v-chip color="green" dark small @click="prospectosAll = item.sinError, dialogReporte = true">{{ item.sinError.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.noIniciado="{ item }">
				        		<v-chip color="yellow" small @click="prospectosAll = item.noIniciado, dialogReporte = true">{{ item.noIniciado.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.total="{ item }">
				        		<v-chip color="yellow" small @click="prospectosAll = item.total, dialogReporte = true">{{ item.total.length }} </v-chip>
				        	</template>

				        </v-data-table>
		    			</v-card-text>
		    		</v-card>					
		    	</v-col>

		    	<v-divider></v-divider>

		    	<v-col cols="12">
		    		<v-card class="elevation-0">
		    			<v-card-title primary-title class="text-body-1">
		    			  Reporte Fast
		    			  <v-spacer></v-spacer>
		    			  <v-btn 
				          class="mr-2" 
				          small dark color="green"
				          @click="exportExcel( vendFast  , 'REPORTE_FAST')"
				          tile
				        >
				          <v-icon small>mdi-microsoft-excel</v-icon>
				        </v-btn>
		    			</v-card-title>
		    			<v-card-text>
			    		  <v-data-table
				          :headers="headers"
				          :items="vendFast"
				          class="elevation-0"
				          dense
				          mobile-breakpoint="200"
				          item-key="nombre"
				        >

									<template v-slot:item.prospectos="{ item }">
				        		<v-chip color="primary" small @click="prospectosAll = item.prospectos, dialogReporte = true">{{ item.prospectos.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.seguimiento="{ item }">
				        		<v-chip color="primary" small @click="prospectosAll = item.seguimiento, dialogReporte = true">{{ item.seguimiento.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.tarda="{ item }">
				        		<v-chip color="primary" small @click="prospectosAll = item.tarda, dialogReporte = true">{{ item.tarda.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.tarda="{ item }">
				        		<v-chip color="primary" small @click="prospectosAll = item.tarda, dialogReporte = true">{{ item.tarda.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.bueno="{ item }">
				        		<v-chip color="green" dark small @click="prospectosAll = item.bueno, dialogReporte = true">{{ item.bueno.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.regular="{ item }">
				        		<v-chip color="orange" dark small @click="prospectosAll = item.regular, dialogReporte = true">{{ item.regular.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.malo="{ item }">
				        		<v-chip color="black" dark small @click="prospectosAll = item.malo, dialogReporte = true">{{ item.malo.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.sin_seguimiento="{ item }">
				        		<v-chip color="red" dark small @click="prospectosAll = item.sin_seguimiento, dialogReporte = true">{{ item.sin_seguimiento.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.cliente_nunca_respondio="{ item }">
				        		<v-chip color="blue" dark small @click="prospectosAll = item.cliente_nunca_respondio, dialogReporte = true">{{ item.cliente_nunca_respondio.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.cliente_dejo_responder="{ item }">
				        		<v-chip color="pink" dark small @click="prospectosAll = item.cliente_dejo_responder, dialogReporte = true">{{ item.cliente_dejo_responder.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.cliente_en_espera="{ item }">
				        		<v-chip color="yellow" small @click="prospectosAll = item.cliente_en_espera, dialogReporte = true">{{ item.cliente_en_espera.length }} </v-chip>
				        	</template>
				        	
				        	<template v-slot:item.msnDuplicado="{ item }">
				        		<v-chip color="red" dark small @click="prospectosAll = item.msnDuplicado, dialogReporte = true">{{ item.msnDuplicado.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.pdfInicio="{ item }">
				        		<v-chip color="blue" dark small @click="prospectosAll = item.pdfInicio, dialogReporte = true">{{ item.pdfInicio.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.clienteEspera="{ item }">
				        		<v-chip color="orange" dark small @click="prospectosAll = item.clienteEspera, dialogReporte = true">{{ item.clienteEspera.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.sinError="{ item }">
				        		<v-chip color="green" dark small @click="prospectosAll = item.sinError, dialogReporte = true">{{ item.sinError.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.noIniciado="{ item }">
				        		<v-chip color="yellow" small @click="prospectosAll = item.noIniciado, dialogReporte = true">{{ item.noIniciado.length }} </v-chip>
				        	</template>

				        	<template v-slot:item.total="{ item }">
				        		<v-chip color="yellow" small @click="prospectosAll = item.total, dialogReporte = true">{{ item.total.length }} </v-chip>
				        	</template>

				        </v-data-table>
		    			</v-card-text>
		    		</v-card>					
		    	</v-col>

		    </v-row>
		  </v-card-text>
		  <v-card-actions>
		  	<v-btn 
		  		tile
		  		top
		  		absolute
		  		icon
		  		right
		  		@click="dialogReporteVendedora.estatus = false"
		  	>
		  		<v-icon small left>mdi-close</v-icon>
		  	</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
		</v-card>

		<v-dialog
		  v-model="dialogMensajes"
		  max-width="1400px"
		>
		  <v-card>
		    <v-card-title class="text-subtitle-1">
		      Datos de los contactos
		      <v-spacer></v-spacer>
		      <v-btn 
	          class="mr-10" 
	          small dark color="green"
	          @click="exportExcel( dataTableContactos  , 'MENSAJES')"
	          tile
	        >
	          <v-icon small>mdi-microsoft-excel</v-icon>
	        </v-btn>
		    </v-card-title>

		    <v-card-text>
		      <v-data-table
	          :headers="headers"
	          :items="dataTableContactos"
	          class="elevation-0"
	          dense
	          mobile-breakpoint="200"
	        >
	        </v-data-table>
		    </v-card-text>
		    <v-card-actions>
		  	<v-btn 
		  		tile
		  		top
		  		absolute
		  		icon
		  		right
		  		@click="dialogMensajes = false"
		  	>
		  		<v-icon small left>mdi-close</v-icon>
		  	</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
		  </v-card>
		</v-dialog>

		<v-dialog
		  v-model="dialogReporte"
		  max-width="1400px"
		>
		  <v-card>
		    <v-card-title class="text-subtitle-1">
		      Contactos
		      <v-spacer></v-spacer>
		      <v-btn 
	          class="mr-10" 
	          small dark color="green"
	          @click="exportExcel( prospectosAll  , 'MENSAJES')"
	          tile
	        >
	          <v-icon small>mdi-microsoft-excel</v-icon>
	        </v-btn>
		    </v-card-title>

		    <v-card-text>
		      <v-data-table
		      	v-model="selected"
	          :headers="headersProspectos"
	          :items="prospectosAll"
	          class="elevation-0"
	          dense
	          mobile-breakpoint="200"
	          item-key="nombre"
    				show-select
	        >

	        	<template v-slot:item.estatus_seguimiento="{ item }">
	        		<v-chip color="green"   dark small v-if="item.estatus_seguimiento == 1">Bueno</v-chip>
	        		<v-chip color="orange"  dark small v-if="item.estatus_seguimiento == 2">Regular</v-chip>
	        		<v-chip color="black"   dark small v-if="item.estatus_seguimiento == 3">Malo</v-chip>
	        		<v-chip color="red"     dark small v-if="item.estatus_seguimiento == 4">Sin seguimiento</v-chip>
	        		<v-chip color="blue"    dark small v-if="item.estatus_seguimiento == 5">Cliente nunca respondió</v-chip>
	        	</template>

	        </v-data-table>
		    </v-card-text>
		    <v-card-actions>
		  	<v-btn 
		  		tile
		  		top
		  		absolute
		  		icon
		  		right
		  		@click="dialogReporte = false"
		  	>
		  		<v-icon small left>mdi-close</v-icon>
		  	</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
		  </v-card>
		</v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-dialog>
</template>
<script>
	import axios from 'axios';
	import { mapGetters } from "vuex";
	// Componentes
	import Alerta from "@/components/alertas/Alerta.vue";
	import carga from "@/components/alertas/carga.vue";

	import validarErrores from "@/mixins/validarErrores";
	import funcionesExcel from "@/mixins/funcionesExcel";

	import * as am5 from "@amcharts/amcharts5";
	import * as am5xy from "@amcharts/amcharts5/xy";
	import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

  import VendedoraSeguimiento       from '@/components/leads/VendedoraSeguimiento'


	export default {

	  mixins: [ validarErrores, funcionesExcel ],

	  props: ['dialogReporteVendedora','escuela', 'tablaInbi', 'tablaFast', 'vendedoras' ],

	  components: {
	    Alerta,
	    carga,
	    VendedoraSeguimiento
	  },

		data: () => ({
	    // Alertas
	    parametros:{
	      dialogError: false,
	      mensaje: '',
	      color: ''
	    },

	    respuestaAlerta:false,
	    loader: true,
	    cargar: false,

	    planteles:[],

	    selected:[],

	    verGraficaInbi: false,
	    verGraficaFast: false,
	    chart: null,
      root: null,
      loading: true,

      dataTableContactos:[],
			dialogMensajes: false,


			headers:[
				{ text: "Vendedora"                     , value: "nombre"                   },
        { text: "No se ha mandado 1er mensaje"  , value: "noIniciado"               },
        { text: "Cliente espera"                , value: "clienteEspera"            },
        { text: "Msn Duplicado"                 , value: "msnDuplicado"             },
        { text: "Pdf en los 1eros Msn"          , value: "pdfInicio"                },
        { text: "Sin error"                     , value: "sinError"                 },
        { text: "Total"                         , value: "total"                    },
        // { text: "Da seguimiento"                , value: "seguimiento"              },
        // { text: "Se tarda"                      , value: "tarda"                    },
        // { text: "Prospectos"                    , value: "prospectos"               },
        // { text: "Bueno"                         , value: "bueno"                    },
        // { text: "Regular"                       , value: "regular"                  },
        // { text: "Malo"                          , value: "malo"                     },
        // { text: "Sin seguimiento"               , value: "sin_seguimiento"          },
        // { text: "Cl. nunca respondió"           , value: "cliente_nunca_respondio"  },
        // { text: "Cl. dejó de responder"         , value: "cliente_dejo_responder"   },
        // { text: "Cl. en espera"                 , value: "cliente_en_espera"        },
			],

			headersProspectos:[
        { text: "Folio"              , value: "folio"               },
        { text: "Twilio"             , value: "twilio"              },
        { text: "Nombre"             , value: "nombre_completo"     },
        { text: "Vendedora"          , value: "vendedora"           },
        { text: "Tiempo Promedio"    , value: "tiempo_promedio"     },
        { text: "Mensajes Repetidos" , value: "mensajes_repetidos"  },
        { text: "#Msn Texto"         , value: "mensajes_texto"      },
        { text: "# PDF"              , value: "mensajes_pdf"        },
        { text: "# Audios"           , value: "mensajes_audios"     },
        { text: "Estatus"            , value: "estatus_seguimiento" },
			],

			vendedora: null,

			dialogMensajesRepetidos: false,
			mensajesRepetidos: [],

			vendedorasInbi: [],
			vendedorasFast: [],

			dialogReporte: false,

			prospectosAll:[]


	  }),

	  computed: {

	  	...mapGetters('login',['getdatosUsuarioERPERP']),

	    formTitle () {
	      return this.editedIndex === -1 ? 'Agregar Diapositiva' : 'Editar Diapositiva'
	    },


	    vendInbi( ){

	    	// await this.initialize()

		    let data = this.vendedoras.filter( el => el.escuela == 1 )

				data = [...new Map(data.map(i => [i.nombre, i])).values()];

				// Ahora vamos a sacar los prospectos sin seguimiento
				// estatus_seguimiento
				for( const i in data ){

					const { id_vendedora } = data[i]

					let prospectos = this.tablaInbi.filter( el => el.usuario_asignado == id_vendedora )

					data[i]['prospectos']              = prospectos
					data[i]['seguimiento']             = prospectos.filter( el => el.estatus_seguimiento == 4 )
					data[i]['tarda']                   = prospectos.filter( el => el.tardo_mas_15min == 1 )
					data[i]['bueno']                   = prospectos.filter( el => el.estatus_seguimiento == 1 )
					data[i]['regular']                 = prospectos.filter( el => el.estatus_seguimiento == 2 )
					data[i]['malo']                    = prospectos.filter( el => el.estatus_seguimiento == 3 )
					data[i]['sin_seguimiento']         = prospectos.filter( el => el.estatus_seguimiento == 4 )
					data[i]['cliente_nunca_respondio'] = prospectos.filter( el => el.estatus_seguimiento == 5 )
					data[i]['cliente_dejo_responder']  = prospectos.filter( el => el.estatus_seguimiento == 6 )
					data[i]['cliente_en_espera']       = prospectos.filter( el => el.estatus_seguimiento == 7 )

					data[i]['msnDuplicado']       = prospectos.filter( el => el.msnDuplicado )
					data[i]['pdfInicio']          = prospectos.filter( el => el.pdfInicio )
					data[i]['clienteEspera']      = prospectos.filter( el => el.clienteEspera )
					data[i]['sinError']           = prospectos.filter( el => el.sinError )
					data[i]['noIniciado']         = prospectos.filter( el => el.noIniciado )
					data[i]['total']              = prospectos

				}

				data.push({
					nombre: 'TOTAL',
					msnDuplicado: this.tablaInbi.filter( el => el.msnDuplicado ),
					pdfInicio: this.tablaInbi.filter( el => el.pdfInicio ),
					clienteEspera: this.tablaInbi.filter( el => el.clienteEspera ),
					sinError: this.tablaInbi.filter( el => el.sinError ),
					noIniciado: this.tablaInbi.filter( el => el.noIniciado ),
					total: this.tablaInbi,
				})

	    	return data

	    },


	    vendFast( ){

	    	// await this.initialize()

		    let data = this.vendedoras.filter( el => el.escuela == 2 )

				data = [...new Map(data.map(i => [i.nombre, i])).values()];

				// Ahora vamos a sacar los prospectos sin seguimiento
				// estatus_seguimiento
				for( const i in data ){

					const { id_vendedora } = data[i]

					let prospectos = this.tablaFast.filter( el => el.usuario_asignado == id_vendedora )

					data[i]['prospectos']              = prospectos
					data[i]['seguimiento']             = prospectos.filter( el => el.estatus_seguimiento == 4 )
					data[i]['tarda']                   = prospectos.filter( el => el.tardo_mas_15min == 1 )
					data[i]['bueno']                   = prospectos.filter( el => el.estatus_seguimiento == 1 )
					data[i]['regular']                 = prospectos.filter( el => el.estatus_seguimiento == 2 )
					data[i]['malo']                    = prospectos.filter( el => el.estatus_seguimiento == 3 )
					data[i]['sin_seguimiento']         = prospectos.filter( el => el.estatus_seguimiento == 4 )
					data[i]['cliente_nunca_respondio'] = prospectos.filter( el => el.estatus_seguimiento == 5 )
					data[i]['cliente_dejo_responder']  = prospectos.filter( el => el.estatus_seguimiento == 6 )
					data[i]['cliente_en_espera']       = prospectos.filter( el => el.estatus_seguimiento == 7 )

					data[i]['msnDuplicado']       = prospectos.filter( el => el.msnDuplicado )
					data[i]['pdfInicio']          = prospectos.filter( el => el.pdfInicio )
					data[i]['clienteEspera']      = prospectos.filter( el => el.clienteEspera )
					data[i]['sinError']           = prospectos.filter( el => el.sinError )
					data[i]['noIniciado']         = prospectos.filter( el => el.noIniciado )
					data[i]['total']              = prospectos

				}

				data.push({
					nombre: 'TOTAL',
					msnDuplicado: this.tablaFast.filter( el => el.msnDuplicado ),
					pdfInicio: this.tablaFast.filter( el => el.pdfInicio ),
					clienteEspera: this.tablaFast.filter( el => el.clienteEspera ),
					sinError: this.tablaFast.filter( el => el.sinError ),
					noIniciado: this.tablaFast.filter( el => el.noIniciado ),
					total: this.tablaFast,
				})
				
	    	return data

	    }

	  },

	  watch: {
	    dialogDelete (val) {
	      val || this.closeDelete( )
	    },

	    fechaini ( val ){
	      val || this.initialize( )
	    }
	  },

	  async created () {
	    // await this.initialize()

	    this.vendedorasInbi = this.vendedoras.filter( el => el.escuela == 1 )
			this.vendedorasFast = this.vendedoras.filter( el => el.escuela == 2 )

			this.vendedorasInbi = [...new Map(this.vendedorasInbi.map(i => [i.nombre, i])).values()];
			this.vendedorasFast = [...new Map(this.vendedorasFast.map(i => [i.nombre, i])).values()];


			// Ahora vamos a sacar los prospectos sin seguimiento
			// estatus_seguimiento
			for( const i in this.vendedorasInbi ){

				const { id_vendedora } = this.vendedorasInbi[i]

				let prospectos = this.tablaInbi.filter( el => el.usuario_asignado == id_vendedora )

				this.vendedorasInbi[i]['prospectos']              = prospectos
				this.vendedorasInbi[i]['seguimiento']             = prospectos.filter( el => el.estatus_seguimiento == 4 )
				this.vendedorasInbi[i]['tarda']                   = prospectos.filter( el => el.tardo_mas_15min == 1 )
				this.vendedorasInbi[i]['bueno']                   = prospectos.filter( el => el.estatus_seguimiento == 1 )
				this.vendedorasInbi[i]['regular']                 = prospectos.filter( el => el.estatus_seguimiento == 2 )
				this.vendedorasInbi[i]['malo']                    = prospectos.filter( el => el.estatus_seguimiento == 3 )
				this.vendedorasInbi[i]['sin_seguimiento']         = prospectos.filter( el => el.estatus_seguimiento == 4 )
				this.vendedorasInbi[i]['cliente_nunca_respondio'] = prospectos.filter( el => el.estatus_seguimiento == 5 )
				this.vendedorasInbi[i]['cliente_dejo_responder']  = prospectos.filter( el => el.estatus_seguimiento == 6 )
				this.vendedorasInbi[i]['cliente_en_espera']       = prospectos.filter( el => el.estatus_seguimiento == 7 )

				this.vendedorasInbi[i]['msnDuplicado']       = prospectos.filter( el => el.msnDuplicado )
				this.vendedorasInbi[i]['pdfInicio']          = prospectos.filter( el => el.pdfInicio )
				this.vendedorasInbi[i]['clienteEspera']      = prospectos.filter( el => el.clienteEspera )
				this.vendedorasInbi[i]['sinError']           = prospectos.filter( el => el.sinError )
				this.vendedorasInbi[i]['noIniciado']         = prospectos.filter( el => el.noIniciado )
				this.vendedorasInbi[i]['total']              = prospectos

			}

			for( const i in this.vendedorasFast ){

				const { id_vendedora } = this.vendedorasFast[i]

				let prospectos = this.tablaFast.filter( el => el.usuario_asignado == id_vendedora )

				this.vendedorasFast[i]['prospectos']              = prospectos
				this.vendedorasFast[i]['seguimiento']             = prospectos.filter( el => el.estatus_seguimiento == 4 )
				this.vendedorasFast[i]['tarda']                   = prospectos.filter( el => el.tardo_mas_15min == 1 )
				this.vendedorasFast[i]['bueno']                   = prospectos.filter( el => el.estatus_seguimiento == 1 )
				this.vendedorasFast[i]['regular']                 = prospectos.filter( el => el.estatus_seguimiento == 2 )
				this.vendedorasFast[i]['malo']                    = prospectos.filter( el => el.estatus_seguimiento == 3 )
				this.vendedorasFast[i]['sin_seguimiento']         = prospectos.filter( el => el.estatus_seguimiento == 4 )
				this.vendedorasFast[i]['cliente_nunca_respondio'] = prospectos.filter( el => el.estatus_seguimiento == 5 )
				this.vendedorasFast[i]['cliente_dejo_responder']  = prospectos.filter( el => el.estatus_seguimiento == 6 )
				this.vendedorasFast[i]['cliente_en_espera']       = prospectos.filter( el => el.estatus_seguimiento == 7 )

				this.vendedorasFast[i]['msnDuplicado']       = prospectos.filter( el => el.msnDuplicado )
				this.vendedorasFast[i]['pdfInicio']          = prospectos.filter( el => el.pdfInicio )
				this.vendedorasFast[i]['clienteEspera']      = prospectos.filter( el => el.clienteEspera )
				this.vendedorasFast[i]['sinError']           = prospectos.filter( el => el.sinError )
				this.vendedorasFast[i]['noIniciado']         = prospectos.filter( el => el.noIniciado )
				this.vendedorasFast[i]['total']              = prospectos

			}


	  },

	  mounted() {
	    
	  },

	  beforeDestroy() {
	    if (this.root) {
	      this.root.dispose();
	    }
  	},

	  methods: {

	    initialize() {
	      this.cargar = true;
	      this.vendedoras = []

	      const payload = {
	        fechaini : this.fechaini,
	        fechafin : this.fechafin
	      }

	      return axios.post('reporte.buen.seguimiento', payload ).then(response => {

	      	this.tablaInbi  = response.data.prospectosTwilioInbi 
	      	this.tablaFast  = response.data.prospectosTwilioFast 
	      	this.vendedoras = response.data.vendedorasAll 


	        // DATOS PARA LA GRAFICA
	        this.cargar = false;

	      }).catch(error => {
	        this.validarError(error.response.data.message);
	      }).finally(() => {
	        this.cargar = false;
	      });
	    },

	    close () {
	      this.dialog = false
	      this.$nextTick(() => {
	        this.editedItem = Object.assign({}, this.defaultItem)
	        this.editedIndex = -1
	      })
	    },

	    closeDelete () {
	      this.dialogDelete = false
	      this.$nextTick(() => {
	        this.editedItem = Object.assign({}, this.defaultItem)
	        this.editedIndex = -1
	      })
	    },

	    verMensajes( item ){
	      this.mensaje = null
	      this.mensaje = item.utlimomensaje
	      this.dialogVerMensaje = true
	    },

	    abrirDatos( datos ){

	    	console.log( datos )

	    	this.dataTableContactos = datos
	    	this.dialogMensajes = true
	    }

	  },
	}
</script>
<style scoped>
  .dropZone {
    width: 80%;
    height: 150px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone:hover {
    border: 2px solid #D8D8D8;
  }

  .dropZone:hover .dropZone-title {
    color: #1975A0;
  }

  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  ..dropZone-title {
    color: #787878;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .dropZone-over {
    background: #D8D8D8;
    opacity: 0.8;
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #D8D8D8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .removeFile {
    width: 200px;
  }

  .chat {
    width: calc(100%);
  }

  .chat .messages-chat {
    padding: 25px 10px;
  }

  .chat .messages-chat .message {
    display:flex;
    align-items: center;
    margin-bottom: 2px;
  }

  .chat .messages-chat .message .photo {
    display: block;
    width: 45px;
    height: 45px;
    background: #E6E7ED;
    -moz-border-radius: 50px;
    -webkit-border-radius: 50px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .chat .messages-chat .text {
    margin: 0 35px;
    background-color: #fff;
    padding: 15px;
    border-radius: 12px;
  }

  .text-only {
    white-space: pre-line;

  }

  .time {
    font-size: 12px;
    color:lightgrey;
    margin-bottom:10px;
    margin-left: 38px;
  }

  .response-time {
    float: right;
    margin-right: 40px !important;
  }

  .response {
    float: right;
    margin-right: 0px !important;
    margin-left: auto; /* flexbox alignment rule */
    max-width: 90%;
  }

  .noresponse {
    max-width: 90%;
  }

  .noresponse .text{
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
  }

  .response .text {
    background-color: #c5e6c1 !important;
    color: black;
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;

  }

  .audio {
    background-color: #f1f3f4 !important;
  }

  .response .audio {
    background-color: #f1f3f4 !important;
  }

  .footer-chat {
    width: calc(65% - 66px);
    height: 80px;
    display:flex;
    align-items: center;
    position:absolute;
    bottom: 0;
    background-color: transparent;
    border-top: 2px solid #EEE;

  }

  .chat .footer-chat .icon {
    margin-left: 30px;
    color:#C0C0C0;
    font-size: 14pt;
  }

  .chat .footer-chat .send {
    color:#fff;
    background-color: #4f6ebd;
    position: absolute;
    right: 50px;
    padding: 12px 12px 12px 12px;
    border-radius: 50px;
    font-size: 14pt;
  }

  .chat .footer-chat .name {
    margin: 0 0 0 20px;
    text-transform: uppercase;
    font-family:'Montserrat', sans-serif;
    font-size: 13pt;
    color:#515151;
  }

  .chat .footer-chat .right {
    position: absolute;
    right: 40px;
  }
</style>